import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: [theme.spacing(2)],
  },
  header: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
  },
  socialBox: {
    width: '100%',
    maxWidth: 500,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    padding: [theme.spacing(2), 0],
  },
  divider: {
    display: 'flex',
    maxWidth: 500,
    width: '100%',
    justifyContent: 'space-between',
  },
  line: {
    width: '45%',
    marginTop: 10,
    borderTop: [1, 'solid', theme.palette.colors.border],
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthSurveyPage/components/BuyerRegistration/useStyles.js